import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbDatepicker, NgbDateStruct, NgbTabset, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { Person } from '../app.component';
import { Spot } from '../app.component';
import { SpotAction } from '../app.component';
import { PersonService } from './user.service';
import { SpotService } from './spot.service';

import { LoginComponent } from '../login/login.component';

@Component({
    selector: 'user-cmp',
    moduleId: module.id,
    templateUrl: 'user.component.html',
    providers: [PersonService, SpotService, LoginComponent]
})

export class UserComponent implements OnInit{

    profile: Person;

    spotText: string;
    spotType: string;
    spotName: string;
    spotDescription: string;
    spotVisible: boolean = true;
    actionVisible: boolean;

    spotsFree: Spot[];
    spotsAll: Spot[];
    spots: Spot[];
    vacateUntil: string;
    date: {year: number, month: number, day: number};

	constructor(private personService: PersonService, private spotService: SpotService, private modalService: NgbModal, private loginComponent: LoginComponent, public router: Router) { }

    ngOnInit(){
        this.reloadData();
    }

    reloadData() {
        var id = localStorage.getItem('selectedUser');
        this.personService.getProfile(parseInt(id)).then(profile => {
             this.profile = profile;
             this.loadSpot();
        });

        this.spotService.getSpots().then(spots => {
             this.spotsFree = spots[0];
             this.spotsAll = spots[1];

             this.spots = this.spotsFree;
        });
    }

    spotStatus(spot: Spot) {
        if (spot.free) {
            if (spot.free_until) {
                return "Free until " + spot.free_until; 
            } else {
                return "Free";
            }
        } else {
            return "Taken";
        }
    }

    loadSpot() {
    	var person = this.profile;
    	var spot: Spot = person.spot;

    	if (spot) {
            this.spotVisible = true;
            this.actionVisible = true;
            this.spotText = "My parking space";
            if (spot.assigned) {
                if (spot.free_until) {;
                    this.spotType = "Assigned space - temporary";
                    this.spotName = spot.code + " - " + person.first_name + " " + person.last_name;
                    this.vacateUntil = spot.free_until;
                    this.spotDescription = spot.departmentName + " - assigned until " + spot.free_until;
                } else {
                    // OneSignal.sendTag("hasSpace", value: spot.id)
                    this.spotType = "Assigned space";
                    this.spotName = spot.code;
                    this.spotDescription = spot.departmentName;
                }
            } else if (spot.permanent) {
                // OneSignal.sendTag("hasSpace", value: spot.id)
                this.spotType = "Permanent space";
                this.spotName = spot.code;
                this.spotDescription = spot.departmentName;
                this.vacateUntil = spot.free_until;
            }
            // dateUntil.isHidden = true
            
        } else {
            // OneSignal.deleteTag("hasSpace")
            // dateUntil.isHidden = true
            this.spotVisible = false;
            this.actionVisible = false;
            this.spotText = "No parking space assigned";
        }
    }

    spotActionTitle(spot: Spot) {
        switch (spot.action) {
            case SpotAction.cancelVacation: {
                return "Cancel vacation";
            }
            case SpotAction.vacate: {
                return "Vacate space";
            }
            case SpotAction.vacateUntil: {
                return "Vacate until";
                // dateUntil.isHidden = false;
            }
            case SpotAction.none: {
                return "Reserve";
            }
        }
    }

    reserveSpot(spot: Spot) {
        this.spotService.reserveSpot(spot).then(response => {
            this.reloadData();
        });

    }

    spotAction(spot: Spot) {
        this.spotService.spotAction(spot, this.vacateUntil).then(response => {
            this.reloadData();
        });

    }

    pickerVisible(person: Person) {
        return person && person.spot && person.spot.permanent;
    }

}



// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/user/user.component.ts